import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
export var GuidGenerator =
/*#__PURE__*/
function () {
  function GuidGenerator() {
    _classCallCheck(this, GuidGenerator);

    this.counter = 0;
  }

  _createClass(GuidGenerator, [{
    key: "reset",
    value: function reset() {
      this.counter = 0;
    }
  }, {
    key: "guid",
    value: function guid() {
      var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var id = ++this.counter;
      return prefix.toString() + id;
    }
  }]);

  return GuidGenerator;
}();